The details of the uploaded candidate profile to be updated.
